import Vue from "vue";
import dayjs from "dayjs";

Vue.filter("dateName", (date: string) => {
  if (!date) {
    return null;
  }
  return dayjs(date).format("MMMM YYYY");
});